import React from 'react';
import { Outlet } from 'react-router-dom';

const LayoutAuth = () => (
  <React.Fragment>
    <main className="site-content">
      <Outlet />
    </main>
  </React.Fragment>
);

export default LayoutAuth;  